import React, { useEffect, useState, useReducer } from "react";
import {
    Header,
    Tabs,
    Box,
    Button,
    Flashbar,
    SpaceBetween,
    Grid,
    Popover,
} from '@amzn/awsui-components-react';
import "../../css/Exception.css"
import ExceptionSummary from "../common/ExceptionSummary";
import ExceptionTrends from "../common/ExceptionTrends";
import {getAcknowledgeDataForVAT, getQuickSightLinkMap, getUserAlias, isObligationUnderReview} from "../../utils/utils";
import ObligationDetails from "../common/ObligationDetails";
import { modifyWorkflowStatus } from "../redux/exceptionAPIs";
import '../../css/style.css';
import Adjustments from "../common/adjustment/Adjustments";
import ExpandableSection from "@amzn/awsui-components-react/polaris/expandable-section";
import ViewDashboards from "./ViewDashboards";
import ViewAttachments from "../common/attachment/ViewAttachments";
import ViewSummaryBreakdown from "./ViewSummaryBreakdown";
import MOGErrorSummary from "./MOGErrorSummary";
import MOGSummary from "./MOGSummary";
import MOGChecklists from "./MOGChecklists";
import SourceSummaryView from "../../../sourceSummary/SourceSummaryView";
import { useNavigate } from "react-router-dom";
import { SOURCE_SUMMARY_DETAILS, sourceSummaryTableReducer, sourceSummaryTableReducerInit } from "../../../sourceSummary/redux/sourceSummaryReducer";
import { fetchSourceSummaryDetails } from "../../../sourceSummary/redux/sourceSummaryAPI";
import { OBLIGATION_STATUS, PHASTOS_OBLIGATION } from "../common/constants";
import { getExceptionTransactionDetails } from "../common/adjustment/constants/errorSummaryUtils";
import { RejectReturnModal } from "../common/RejectReturnModal";
import {ADMINISTRATOR_ROLE, APPROVER_ROLE, REVIEWER_ROLE} from "../../../../common/constants/constants";
import {updateUserRole} from "./mogAPIs";
import {API} from "aws-amplify";
import {PHASTOS_EXPORT_AGGREGATED_REPORT} from "../../../../ApiPaths";
import {getAPIInputContext} from "../../../../common/utils/apiUtils";
import {triggerGetQuickSightEmbedUrl} from "../common/quicksightUtils";
import {
    GET_QUICKSIGHT_EMBED_URL_INITIAL_STATE,
    getQuicksightEmbedUrlInitialState, getQuicksightEmbedUrlReducer
} from "../redux/getQuicksightEmbedUrlReducer";

function MOGException(props) {
    const navigate = useNavigate();

    const {
        alias,
        itemData,
        exceptionSummaryData,
        updateWorkflowStatus,
        updateWorkflowStatusDispatcher,
        domain
    } = props;

    const exceptionData = itemData?.exceptionData;
    const stepsInitialState = getAcknowledgeDataForVAT(itemData?.acknowledgementMap);
    const [stepsState, setStepsState] = useState(stepsInitialState);
    const [approveButtonDisabled, setApproveButtonDisabled] = useState(false);
    const [obligationStatus, setObligationStatus] = useState(itemData?.status);
    const [downloadStatementDisabled, setDownloadStatementDisabled] = useState(false);
    const [summaryLoading, setSummaryLoading] = useState(false);
    const isUnderReview = isObligationUnderReview(obligationStatus);
    const [isTransactionReviewLoading, setIsTransactionReviewLoading] = useState(false);
    const [lastUpdatedOn, setLastUpdatedOn] = useState('-');
    const [downloadSummaryReportFlashbarContent, setDownloadSummaryReportFlashbarContent] = React.useState([]);

    const exceptionSummaryTableProp = [
        {
            'step': 'Summary',
            'status': stepsState.summaryStep.completed ? 'Completed' : 'Pending',
            'person': stepsState.summaryStep.user,
            'date': stepsState.summaryStep.updatedOn,
        },
        {
            'step': 'Insights',
            'status': stepsState.insightStep.completed ? 'Completed' : 'Pending',
            'person': stepsState.insightStep.user,
            'date': stepsState.insightStep.updatedOn,
        },
        {
            'step': 'Transaction review',
            'status': stepsState.transactionReviewStep.completed ? 'Completed' : 'Pending',
            'person': stepsState.transactionReviewStep.user,
            'date': stepsState.transactionReviewStep.updatedOn,
        }
    ];

    const setStepStateHandler = async (step) => {
        const userAlias = await getUserAlias();
        setStepsState({
            ...stepsState,
            [step]: {completed: true, user: userAlias, updatedOn: new Date().toLocaleDateString()},
        });
    };

    const [transactionReviewEditMode, setTransactionReviewEditMode] = useState(true);

    // User Role
    const [userRole, setUserRole] = useState(REVIEWER_ROLE);
    // List in order of priority where former element has higher priority then later
    const roleList = [REVIEWER_ROLE, APPROVER_ROLE, ADMINISTRATOR_ROLE];

    useEffect(()=> {
        updateUserRole(itemData?.obligationName, itemData?.parentWorkflowId, roleList, setUserRole)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Send for Approval

    const isSendForApproveButtonDisabled = () => {
        return !(
            isUnderReview
            && stepsState.summaryStep.completed
            && stepsState.insightStep.completed && stepsState.transactionReviewStep.completed
        );
    };

    const generateUpdatingStatusRequest = (statusValue) => {
        return {
            parentWorkflowId: itemData?.parentWorkflowId,
            status: statusValue,
            acknowledgementStructureMap: {},
        }
    }

    const sendForApproveButtonClickHandler = () => {
        const onSuccess = async () => {
            setApproveButtonDisabled(true);
            setObligationStatus(OBLIGATION_STATUS.UnderApproval)
        };
        modifyWorkflowStatus(updateWorkflowStatusDispatcher,
            generateUpdatingStatusRequest(OBLIGATION_STATUS.UnderApproval),
            onSuccess);
    };

    // Approve Return

    const isApproveButtonDisable = () => {
        return !(
            obligationStatus === OBLIGATION_STATUS.UnderApproval 
            && checklistState.approver.option1 && checklistState.approver.option2 
            && checklistState.approver.option3 && checklistState.approver.option4
        );
    };

    const approveButtonClickHandler = (event) => {
        event.stopPropagation();
        const onSuccess = async () => {
            setObligationStatus(OBLIGATION_STATUS.UnderFiling)
        };
        modifyWorkflowStatus(updateWorkflowStatusDispatcher,
            generateUpdatingStatusRequest(OBLIGATION_STATUS.UnderFiling),
            onSuccess);
    };

    // Reject Return

    const [rejectConfirmModal, setRejectConfirmModal] = useState(false);

    const rejectButtonClickHandler = (event) => {
        event.stopPropagation();
        setRejectConfirmModal(true);
    };

    const rejectConfirmHandler = (rejectReason) => {
        const onSuccess = async () => {
            setObligationStatus(OBLIGATION_STATUS.UnderReview)
        };
        modifyWorkflowStatus(updateWorkflowStatusDispatcher,
            generateUpdatingStatusRequest(OBLIGATION_STATUS.UnderReview),
            onSuccess);
    };

    // Ingestion

    const onIngestionClickHandler = () => {
        setActiveTabId("tenth");
    };

    // Adjustment

    const [adjustmentFlashbar, setAdjustmentFlashbar] = useState([]);

    const onDismissAdjustmentFlashbar = () => {
        setAdjustmentFlashbar([]);
    };

    const [activeTabId, setActiveTabId] = useState('first');

    // Downloads

    const downloadStatement = () => {
        setDownloadStatementDisabled(true);
        setSummaryLoading(true);

        getAPIInputContext().then(async input => {
            input.body.parentWorkflowId = itemData?.parentWorkflowId;
            input.body.phastosUseCaseName = itemData?.phastosUseCaseName;
            input.body.alias = alias;
            input.body.reportingPeriod = itemData?.reportingPeriod;

            API.post("TWIN_API", PHASTOS_EXPORT_AGGREGATED_REPORT, input).then(resp => {
                if (resp.status === 200) {
                    setDownloadSummaryReportFlashbarContent([
                        {
                            type: "success",
                            dismissible: true,
                            onDismiss: () => setDownloadSummaryReportFlashbarContent([]),
                            content: "Intrastat Summary Report has been sent to your email id.",
                            id: "successFlashbar"
                        }
                    ]);
                    setSummaryLoading(false);
                    setDownloadStatementDisabled(false);
                } else {
                    setDownloadSummaryReportFlashbarContent([
                        {
                            type: "error",
                            dismissible: true,
                            onDismiss: () => setDownloadSummaryReportFlashbarContent([]),
                            content: "Intrastat Summary Report could not be sent. Please try again later.",
                            id: "errorFlashbar"
                        }
                    ]);
                    setSummaryLoading(false);
                    setDownloadStatementDisabled(false);
                }
            })
        });
    };

    // eslint-disable-next-line no-unused-vars
    // Checklist

    const [checklistState, setChecklistState] = useState({
        preparer: {
            option1: stepsState.checklistStep.completed,
            option2: stepsState.checklistStep.completed,
            option3: stepsState.checklistStep.completed,
            option4: stepsState.checklistStep.completed,
            option5: stepsState.checklistStep.completed,
            option6: stepsState.checklistStep.completed,
        },
        approver: {
            option1: obligationStatus === OBLIGATION_STATUS.UnderFiling || obligationStatus === OBLIGATION_STATUS.Filed,
            option2: obligationStatus === OBLIGATION_STATUS.UnderFiling || obligationStatus === OBLIGATION_STATUS.Filed,
            option3: obligationStatus === OBLIGATION_STATUS.UnderFiling || obligationStatus === OBLIGATION_STATUS.Filed,
            option4: obligationStatus === OBLIGATION_STATUS.UnderFiling || obligationStatus === OBLIGATION_STATUS.Filed,
        }
    });

    // Filing

    const filingBtnHandler = () => {
        navigate("../../filing", {replace: false});
    };

    // Load VATErrorSummary

    const [transactionSummaryData, setTransactionSummaryData] = useState([]);
    useEffect(() => {
        const request = {
            parentWorkflowId: itemData?.parentWorkflowId,
            setItems: setTransactionSummaryData,
            setIsLoading: setIsTransactionReviewLoading,
            useCase: itemData?.type,
            phastosObligation: PHASTOS_OBLIGATION.MOG
        };
        getExceptionTransactionDetails(request);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // Quicksight Dashboard Embed Links

    const [quicksightEmbedLinks, quickSightEmbedLinksDispatcher] = useReducer(getQuicksightEmbedUrlReducer,
        GET_QUICKSIGHT_EMBED_URL_INITIAL_STATE, getQuicksightEmbedUrlInitialState);

    const quickSightLinkMap = getQuickSightLinkMap(exceptionData);

    useEffect(() => {
        triggerGetQuickSightEmbedUrl(quickSightLinkMap,
            itemData?.obligationName, quicksightEmbedLinks, quickSightEmbedLinksDispatcher);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Load SourceSummaryView

    const [sourceSummaryData, sourceSummaryTableDispatcher] = useReducer(sourceSummaryTableReducer,
        SOURCE_SUMMARY_DETAILS, sourceSummaryTableReducerInit);
    
    const refreshSourceSummaryData = () => {
        sourceSummaryTableDispatcher({
            type: "API_BEGIN_FOR_SOURCE_SUMMARY", payload: {}
        });
        const request = {
            parentWorkflowId: itemData?.parentWorkflowId,
            tableDispatcher: sourceSummaryTableDispatcher,
            useCase: itemData?.obligationName,
            phastosObligation: PHASTOS_OBLIGATION.MOG
        }
        fetchSourceSummaryDetails(request);
    } 
    useEffect(() => {
        refreshSourceSummaryData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const reviewerButtons = () => {
        return (
            <SpaceBetween direction="horizontal" size="xs">
                <Button disabled={obligationStatus !== OBLIGATION_STATUS.UnderFiling}
                        onClick={filingBtnHandler}>E-file</Button>
                <Button disabled={isSendForApproveButtonDisabled() || approveButtonDisabled}
                        onClick={sendForApproveButtonClickHandler}>Complete milestone</Button>
                {(isSendForApproveButtonDisabled() || approveButtonDisabled) &&
                    <Popover
                        position="top"
                        size="small"
                        triggerType="custom"
                        content={
                            <div>
                                All review step not yet completed.
                            </div>
                        }
                    >
                        <Button iconName="status-info" variant="icon"/>
                    </Popover>}

            </SpaceBetween>
        );
    };
    const approverButtons = () => {
        return (
            <SpaceBetween direction="horizontal" size="xs">
                <Button disabled={obligationStatus !== OBLIGATION_STATUS.UnderApproval}
                        onClick={rejectButtonClickHandler}>Reject</Button>
                <Button disabled={isApproveButtonDisable()}
                        onClick={approveButtonClickHandler}>Approve</Button>
                {!(checklistState.approver.option1 && checklistState.approver.option2 && checklistState.approver.option3 && checklistState.approver.option4) &&
                    <Popover
                        position="top"
                        size="small"
                        triggerType="custom"
                        content={
                            <div>
                                Checklist not yet completed.
                            </div>
                        }
                    >
                        <Button iconName="status-info" variant="icon"/>
                    </Popover>}
            </SpaceBetween>
        );
    }
    const reviewerApproverButtons = ({userRole}) => {
        let content;
        if (userRole === REVIEWER_ROLE) {
            content = reviewerButtons();
        } else if (userRole === APPROVER_ROLE) {
            content = approverButtons();
        } else if (userRole === ADMINISTRATOR_ROLE) {
            content = (
                <SpaceBetween direction="horizontal" size="xs">
                    {reviewerButtons()}
                    {approverButtons()}
                </SpaceBetween>
            );
        }
        return content;
    }
    return (
        <>
            <div className="phastos-exception">
                <Flashbar items={adjustmentFlashbar}/>
                <Flashbar items={exceptionSummaryData?.flashBarItem}/>
                <Flashbar items={updateWorkflowStatus?.flashBarItem}/>
                <SpaceBetween size='l'>
                    <div className="progress-card">
                        <ul id="progressbar">
                            <li className="active clickable" id="ingestion" onClick={onIngestionClickHandler}>
                                <strong>Preparation</strong></li>
                            <li className={obligationStatus === OBLIGATION_STATUS.UnderApproval || obligationStatus === OBLIGATION_STATUS.UnderFiling || obligationStatus === OBLIGATION_STATUS.Filed ? "active" : obligationStatus === OBLIGATION_STATUS.UnderReview ? "semi-active" : ""}
                                id="review"><strong>Review</strong></li>
                            <li id="approve"
                                className={obligationStatus === OBLIGATION_STATUS.UnderApproval ? "semi-active" : obligationStatus === OBLIGATION_STATUS.UnderFiling || obligationStatus === OBLIGATION_STATUS.Filed ? "active" : ""}>
                                <strong>Approval</strong></li>
                            <li id="filing_in_progress"
                                className={obligationStatus === OBLIGATION_STATUS.UnderFiling ? "semi-active" : obligationStatus === OBLIGATION_STATUS.Filed ? "active" : ""}>
                                <strong>Filing</strong></li>
                            <li id="filed" style={{width: '0'}}
                                className={obligationStatus === OBLIGATION_STATUS.Filed ? "active" : ""}>
                                <strong>Complete</strong></li>
                        </ul>
                    </div>
                    <Flashbar items={downloadSummaryReportFlashbarContent}/>
                    <ExpandableSection
                        variant="container"
                        header={<Header actions={<SpaceBetween direction="horizontal" size="xs">
                            <div onClick={(e) => {
                                e.stopPropagation()
                            }}>
                                <Button
                                    variant="normal"
                                    loading={summaryLoading}
                                    disabled={downloadStatementDisabled || summaryLoading}
                                    onClick={downloadStatement}
                                >
                                    Export summary
                                </Button>
                            </div>
                            {reviewerApproverButtons({userRole})}
                        </SpaceBetween>}>Obligation overview</Header>}
                    >
                        <Grid gridDefinition={[{colspan: 6}, {colspan: 6}]}>
                            <ObligationDetails data={itemData} obligationStatus={obligationStatus}
                                               phastosObligation={PHASTOS_OBLIGATION.MOG}/>
                            <ExceptionSummary exceptionSummaryTableProp={exceptionSummaryTableProp}/>
                        </Grid>
                    </ExpandableSection>
                    <div>
                        <Tabs
                            tabs={[
                                {
                                    label: 'Reportable summary',
                                    id: 'first',
                                    content: <MOGSummary
                                        parentWorkflowId={itemData?.parentWorkflowId}
                                        useCase={itemData?.phastosUseCaseName}
                                        lastUpdatedOn={lastUpdatedOn}
                                        setLastUpdatedOn={setLastUpdatedOn}
                                        setAdjustmentFlashbar={setAdjustmentFlashbar}
                                        onDismissAdjustmentFlashbar={onDismissAdjustmentFlashbar}
                                        setActiveTabId={setActiveTabId}
                                        onViewBasSummary={setActiveTabId}
                                        obligationStatus={obligationStatus}
                                        isUnderReview={isUnderReview}
                                        stepsState={stepsState}
                                        setStepsStateHandler={setStepStateHandler}
                                        updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                                    />,
                                },
                                {
                                    label: 'Breakdown',
                                    id: 'second',
                                    content: <ViewSummaryBreakdown exceptionData={exceptionData}
                                                                   useCase={itemData?.obligationName}/>,
                                },
                                {
                                    label: 'Source summary',
                                    id: 'tenth',
                                    content: <SourceSummaryView
                                        workflowData={itemData}
                                        sourceSummaryData={sourceSummaryData}
                                        sourceSummaryTableDispatcher={sourceSummaryTableDispatcher}
                                        refreshSourceSummaryData={refreshSourceSummaryData}
                                        phastosObligation={PHASTOS_OBLIGATION.MOG}/>,
                                },
                                {
                                    label: 'Transaction review',
                                    id: 'fifth',
                                    content:
                                        <Box>
                                            <MOGErrorSummary
                                                exceptionData={exceptionData}
                                                isUnderReview={isUnderReview}
                                                quicksightLinkMap={quickSightLinkMap}
                                                quicksightEmbedLinks={quicksightEmbedLinks}
                                                stepsState={stepsState}
                                                obligationStatus={obligationStatus}
                                                setStepsStateHandler={setStepStateHandler}
                                                updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                                                parentWorkflowId={itemData?.parentWorkflowId}
                                                transactionReviewEditMode={transactionReviewEditMode}
                                                setTransactionReviewEditMode={setTransactionReviewEditMode}
                                                transactionSummaryData={transactionSummaryData}
                                                isTransactionReviewLoading={isTransactionReviewLoading}
                                                setIsTransactionReviewLoading={setIsTransactionReviewLoading}
                                                useCase={itemData?.type}
                                                reportingPeriod={itemData?.reportingPeriod}
                                                useCaseType={itemData?.identifierMap?.useCaseType}
                                                phastosUseCaseName={itemData?.phastosUseCaseName}
                                                domain={domain}
                                                phastosObligation={PHASTOS_OBLIGATION.MOG}
                                            />
                                        </Box>
                                },
                                {
                                    label: 'Audit',
                                    id: 'sixth',
                                    content: <Adjustments parentWorkflowId={itemData?.parentWorkflowId}
                                                          isUnderReview={isUnderReview}
                                                          stepsState={stepsState}
                                                          setStepsStateHandler={setStepStateHandler}
                                                          updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                                    />,
                                },
                                {
                                    label: 'Attachments',
                                    id: 'seventh',
                                    content: <ViewAttachments
                                        parentWorkflowId={itemData?.parentWorkflowId}
                                        useCase={itemData?.type}
                                    />,
                                    disabled: false
                                },
                                {
                                    label: 'Insights',
                                    id: 'fourth',
                                    content: <ViewDashboards exceptionData={exceptionData} isUnderReview={isUnderReview}
                                                             stepsState={stepsState}
                                                             setStepsStateHandler={setStepStateHandler}
                                                             updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                                                             parentWorkflowId={itemData?.parentWorkflowId}
                                                             useCase={itemData?.obligationData}
                                    />,
                                },
                                {
                                    label: 'Trends',
                                    id: 'eight',
                                    content: <ExceptionTrends
                                        exceptionData={exceptionData}
                                        useCase={itemData?.obligationData}
                                        isUnderReview={isUnderReview}
                                        stepsState={stepsState}
                                        setStepsStateHandler={setStepStateHandler}
                                        updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                                        parentWorkflowId={itemData?.parentWorkflowId}
                                        isVATReturn={true}
                                    />,
                                },
                                {
                                    label: 'Checklists',
                                    id: 'third',
                                    disabled: true,
                                    content: <MOGChecklists isUnderReview={isUnderReview}
                                                            stepsState={stepsState}
                                                            setStepsStateHandler={setStepStateHandler}
                                                            updateWorkflowStatusDispatcher={updateWorkflowStatusDispatcher}
                                                            parentWorkflowId={itemData?.parentWorkflowId}
                                                            setActiveTabId={setActiveTabId}
                                                            obligationStatus={obligationStatus}
                                                            checklistState={checklistState}
                                                            setChecklistState={setChecklistState}
                                                            userRole={userRole}/>
                                },
                                {
                                    label: 'Filing',
                                    id: 'ninth',
                                    content: <></>,
                                    disabled: true,
                                }
                            ]}
                            activeTabId={activeTabId}
                            onChange={(event) => {
                                setActiveTabId(event.detail.activeTabId)
                            }}
                        />
                    </div>
                </SpaceBetween>
                <RejectReturnModal
                    rejectConfirmModal={rejectConfirmModal}
                    rejectConfirmHandler={rejectConfirmHandler}
                    setRejectConfirmModal={setRejectConfirmModal}
                />
            </div>
        </>
    );
}

export default MOGException;
